/** @jsx jsx */
import { gql } from '@apollo/client';
import { P, SemiTitle, Text } from '@bottlebooks/gatsby-design-system';
import { Col, Row } from '@bottlebooks/gatsby-theme-base/src';
import Section from '@bottlebooks/gatsby-theme-event/src/components/Section/Section';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

const analyticFormat = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 2,
};

function hasContent(product) {
  if (!product) return false;
  if (product.alcohol != null) return true;
  if (product.designation != null) return true;
  return false;
}

export default function ProductAnalytics({ product, ...rest }) {
  const { i18n } = useLingui();
  if (!hasContent(product)) return null;
  const { alcohol, designation } = product;
  return (
    <Section {...rest}>
      <Row>
        {alcohol != null && (
          <Col sx={{ width: [null, '50%'] }}>
            <SemiTitle>
              <Trans>Alcohol</Trans>
            </SemiTitle>
            <P variant="title">{i18n.number(alcohol, analyticFormat)}%</P>
          </Col>
        )}
        {designation != null && (
          <Col sx={{ width: [null, '50%'] }}>
            <SemiTitle>
              <Trans>Analytical data</Trans>
            </SemiTitle>
            {designation && <P variant="title">{designation}</P>}
          </Col>
        )}
      </Row>
    </Section>
  );
}

export const fragment = graphql`
  fragment bb_ProductAnalytics on Bottlebooks_Product {
    alcohol
    residualSugar
    totalAcidity
    ... on Bottlebooks_Wine {
      designation
      pH
    }
  }
`;

ProductAnalytics.fragment = gql`
  fragment ProductAnalytics on Product {
    alcohol
    residualSugar
    totalAcidity
    ... on Wine {
      designation
      pH
    }
  }
`;
